import { render, staticRenderFns } from "./buyFundList.vue?vue&type=template&id=702c2826&scoped=true"
import script from "./buyFundList.vue?vue&type=script&lang=js"
export * from "./buyFundList.vue?vue&type=script&lang=js"
import style0 from "./buyFundList.vue?vue&type=style&index=0&id=702c2826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702c2826",
  null
  
)

export default component.exports